export enum BlocksAssetType {
  BlockNormal = 'block_normal',
  BlockNormalHighlight = 'block_normal_highlight',
  BlockMultiplier = 'block_multiplier',
  BlockMultiplierHighlight = 'block_multiplier_highlight',
  StartButton = 'start_button',
  PlayIcon = 'play_icon',
}

export enum BlocksSpriteType {
  Placeholder = 'placeholder',
}

export enum BlocksTranslationsType {
  Play = 'play',
  Level = 'level',
}
